import React, { useEffect, useState } from 'react'
import { b_fs, c_fs } from '../../../../config/constants'
import { Checkdevice } from '../../../../components'
import './T2.css'
import { allimages } from '../../../../assets/invitationcard/index1'
// const bordercss = ['1px solid transparent', '1px solid #707070']

// FONT SIZE FOR WEB
const datetime_fs_web = b_fs
const schedule_fs_web = c_fs
const qn_fs_web = c_fs
const party_fs_web = c_fs
const map_fs_web = c_fs
const btmbar_stub = <div className='ILOOKUP_BTMSTUB' style={{ minHeight: 110 }} />
const stickytopnavht = 60
const TEMPLATE2 = 2
export const T1border = ({ children, styleborder, styleborderbr, stylebordercolor, styleborderwt, menutype }) => {
    // menutype === 'stickytopnav'
    const borderradius = styleborderbr ? '4vmin' : '0px'
    const borderwt = styleborderwt ? 5 : 3
    const margintop = menutype === 'stickytopnav' ? stickytopnavht : 0
    return [
        // 0
        children,
        // 1
        <div style={{ top: margintop, borderRadius: borderradius, border: `${borderwt}px solid ${stylebordercolor}`, width: `calc(100% - ${borderwt}px)`, margin: borderwt, display: 'flex', flexDirection: 'column', minHeight: '100%', alignItems: 'center', justifyContent: 'center', zIndex: 'initial' }}>
            {children}
        </div>,
        // 2
        <div style={{ borderRadius: borderradius, border: `${borderwt}px solid ${stylebordercolor}`, width: `calc(100% - ${borderwt}px)`, margin: borderwt, display: 'flex', flexDirection: 'column', minHeight: '100%', alignItems: 'center', justifyContent: 'center', zIndex: 'initial' }}>
            <div style={{ marginTop: margintop, borderRadius: `calc( ${borderradius} * 0.8 )`, border: `${borderwt}px solid ${stylebordercolor}`, width: `calc( 100% - 12px)`, margin: borderwt * 2, display: 'flex', flexDirection: 'column', minHeight: '100%', alignItems: 'center', justifyContent: 'center', zIndex: 'initial' }}>
                {children}
            </div>
        </div>,
        // 5
        <div className="bordert1" style={{ borderRadius: borderradius, border: `${borderwt}px solid ${stylebordercolor}`, width: `calc(100% - ${borderwt * 2}px)`, margin: borderwt, display: 'flex', flexDirection: 'column', minHeight: '100%', alignItems: 'center', justifyContent: 'center', zIndex: 'initial' }}>
            {children}
            <div className="T1_TOP" style={{ marginTop: margintop, display: 'flex', position: 'absolute', top: 0, left: 0, flexDirection: 'row', width: '100%', height: '100%', placeContent: 'space-between' }}>
                {/* left */}
                <div className="T1_TOP_LEFT" style={{ position: 'relative', top: borderwt * 2, left: borderwt * 2 }}>
                    <div style={{ width: 40, height: 80, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius }} />
                    <div style={{ width: 80, height: 40, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius }} />
                </div >
                {/* right */}
                <div className="T1_TOP_RIGHT" style={{ position: 'relative', top: borderwt * 2, right: borderwt * 2, transform: "scale(-1,1)", }}>
                    <div style={{ width: 40, height: 80, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius }} />
                    <div style={{ width: 80, height: 40, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius }} />
                </div >
            </div>

            <div className="T1_BTM" style={{ marginTop: margintop, display: 'flex', flexDirection: 'row', width: '100%', height: '100%', placeContent: 'space-between', position: 'relative' }}>
                <div className="T1_BTM_LEFT" style={{ position: 'relative' }}>
                    <div style={{ width: 40, height: 80, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 80, height: 40, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                </div>
                <div className="T1_BTM_RIGHT" style={{ position: 'relative', transform: "scale(-1,1)" }}>
                    <div style={{ width: 40, height: 80, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 80, height: 40, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                </div>
            </div>
        </div>,
        // 6
        <div className="bordert1" style={{ borderRadius: borderradius, border: `${borderwt}px solid ${stylebordercolor}`, width: `calc(100% - ${borderwt * 2}px)`, margin: borderwt, display: 'flex', flexDirection: 'column', minHeight: '100%', alignItems: 'center', justifyContent: 'center', zIndex: 'initial' }}>
            {children}

            <div className="T1_TOP" style={{ marginTop: margintop, display: 'flex', position: 'absolute', top: 0, left: 0, flexDirection: 'row', width: '100%', height: '100%', placeContent: 'space-between' }}>
                {/* left */}
                <div className="T1_TOP_LEFT" style={{ position: 'relative', top: borderwt * 2, left: borderwt * 2 }}>
                    <div style={{ width: 30, height: 90, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, borderTopLeftRadius: 0 }} />
                    <div style={{ width: 60, height: 60, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, borderTopLeftRadius: 0 }} />
                    <div style={{ width: 90, height: 30, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, borderTopLeftRadius: 0 }} />
                </div >
                {/* right */}
                <div className="T1_TOP_RIGHT" style={{ position: 'relative', top: borderwt * 2, right: borderwt * 2, transform: "scale(-1,1)", }}>
                    <div style={{ width: 30, height: 90, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, }} />
                    <div style={{ width: 60, height: 60, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, }} />
                    <div style={{ width: 90, height: 30, position: 'absolute', border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderTop: 'none', borderBottomRightRadius: borderradius, }} />
                </div >
            </div>
            <div className="T1_BTM" style={{ marginTop: margintop, display: 'flex', flexDirection: 'row', width: '100%', height: '100%', placeContent: 'space-between', position: 'relative' }}>
                {/* left */}
                <div className="T1_BTM_LEFT" style={{ position: 'relative' }}>
                    <div style={{ width: 30, height: 90, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 60, height: 60, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 90, height: 30, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                </div>
                {/* right */}
                <div className="T1_BTM_RIGHT" style={{ position: 'relative', transform: "scale(-1,1)" }}>
                    <div style={{ width: 30, height: 90, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 60, height: 60, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                    <div style={{ width: 90, height: 30, border: `${borderwt}px solid ${stylebordercolor}`, borderLeft: 'none', borderBottom: 'none', borderTopRightRadius: borderradius, position: 'absolute', bottom: 0 }} />
                </div>
            </div>
        </div>,
    ][styleborder]
}

function T2(props) {

    const {

        wt, ht, WEB_TABLET_WT,

        name1, name2,

        // DATA FROM BACKEND
        prebuildtemplatedesign_map,
        templatecolor,
        textures,
        priff,
        imgcss_map,

        // sequence 
        displayseq,

        // border
        styleborder,
        styleborderbr, // border radius
        stylebordercolor,// border color
        styleborderwt, // border width, true is thick, false is thin

        showtitle,

        menutype, // none, btmnavbar, stickytopnav, menu, btmnavbarwithouticon,

        // FACTORY OF DOMS
        T2titles_dom,
        pagescrolldown_dom,
        mainimg_dom,
        alticlinks_dom,
        qns_dom,
        socialmedia_dom,
        rsvpbtn_dom,
        party_dom,
        maintext_dom,
        subtext_dom,
        location_dom,
        datetime_dom,
        schedule_dom,
        map_dom,
        proposal_dom,
        howwemet_dom,
        bar_dom,

        // FONT SIZE FOR MOBILE
        maintext_fs_mobile,
        subtext_fs_mobile,
        qn_fs_mobile,
        datetime_fs_mobile,
        schedule_fs_mobile,
        map_fs_mobile,
        party_fs_mobile

    } = props

    const fontcolor = '#707070'
    // const fontcolor = 'white'

    const device = Checkdevice()

    const [seq_dom, setSeq_dom] = useState({
        'maintext': <div key={'maintext'}/>,
        'location': <div key={'location'}/>,
        'date': <div key={'date'}/>,
        'howwemet':<div key={'howwemet'}/>,
        'proposal': <div key={'proposal'}/>,
        'schedule': <div key={'schedule'}/>,
        'qna': <div key={'qna'}/>,
        'map': <div key={'map'}/>,
        'rsvp': <div key={'rsvp'}/>,
        'party': <div key={'party'}/>,
    })

    const [firsttime, setFirsttime] = useState(true)

    useEffect(() => {
        if (firsttime) {
            if (device === 'WEB' || device === 'TABLET') {
                setSeq_dom({
                    'maintext': maintext_dom(WEB_TABLET_WT * 0.875, c_fs),
                    'location': location_dom(WEB_TABLET_WT * 0.875, 999),
                    'date': datetime_dom, // 'date': datetime_dom(datetime_fs_web),
                    'howwemet': howwemet_dom(WEB_TABLET_WT * 0.875, c_fs),
                    'proposal': proposal_dom(WEB_TABLET_WT * 0.875, c_fs),
                    'schedule': schedule_dom(WEB_TABLET_WT * 0.875, 'max-content', schedule_fs_web),
                    'qna': qns_dom(WEB_TABLET_WT * 0.875, qn_fs_web),
                    'map': map_dom(WEB_TABLET_WT * 0.875, map_fs_web),
                    'rsvp': rsvpbtn_dom(WEB_TABLET_WT * 0.875),
                    'party': party_dom(WEB_TABLET_WT * 0.875, party_fs_web),
                })
            }
            else if (device === 'MOBILE') {
                setSeq_dom({
                    'maintext': maintext_dom(wt * 0.95, maintext_fs_mobile),
                    'location': location_dom(wt * 0.95, 999),
                    'date': datetime_dom, // 'date': datetime_dom(datetime_fs_mobile),
                    'howwemet': howwemet_dom(wt * 0.95, maintext_fs_mobile),
                    'proposal': proposal_dom(wt * 0.95, maintext_fs_mobile),
                    'schedule': schedule_dom(wt * 0.95, 'max-content', schedule_fs_mobile),
                    'qna': qns_dom(wt * 0.95, qn_fs_mobile),
                    'map': map_dom(wt * 0.95, map_fs_mobile),
                    'rsvp': rsvpbtn_dom(wt * 0.95),
                    'party': party_dom(wt * 0.95, party_fs_mobile),
                })
            }
            setFirsttime(false)
        }
    }, [firsttime])

    if ((prebuildtemplatedesign_map && prebuildtemplatedesign_map[TEMPLATE2])) {

        const monogram_dom = name1.length > 0 && name2.length > 0
            ? <div
                className='T2_namemonogram'
                style={{ color: props.fc, fontSize: { 'WEB': 120, 'TABLET': 104, 'MOBILE': '5em' }[device] }}
            >
                <div className='T2_namemonogramleft'>{`${name1[0]} `}</div>
                <div className='T2_namemonogramand'>{"&"}</div>
                <div className='T2_namemonogramright'>{` ${name2[0]}`}</div>
            </div>
            : null


        if (device === 'WEB' || device === 'TABLET') {

            const deviceimgmultiplier = imgcss_map ? imgcss_map[{ 'WEB': 'webimgconstant', 'TABLET': 'tabletimgconstant', 'MOBILE': 'mobileimgconstant' }[device]] : 1
            const imgwt = WEB_TABLET_WT * deviceimgmultiplier

            const topbg_dom = <img
                className='T2_bgimgtop'
                src={allimages.get(prebuildtemplatedesign_map[TEMPLATE2]['styletype'])['t2']['bgtop']}
            />

            const btmbg_dom = <img
                className='T2_bgimgbtm'
                src={allimages.get(prebuildtemplatedesign_map[TEMPLATE2].styletype)['t2']['bgbtm']}
            />

            return <div
                id="ilookupt1"
                style={{
                    overflowY: props.showpromote ? 'hidden' : '', overflowX:'hidden',display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center',
                    minHeight: ht, color: fontcolor, backgroundColor: templatecolor, backgroundImage: `url(${textures[0]})`, fontFamily: priff, marginTop: menutype === 'stickytopnav' ? stickytopnavht : 0
                }}
            >
                {T2titles_dom('100%')}
                {mainimg_dom('100%', 999, 0)}
                {topbg_dom}
                {/* {monogram_dom} */}
                <div style={{ backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', width: '100%', display: 'flex', flexDirection: 'column', zIndex: 999, justifyContent: 'center' }}>
                    {/* {seq_dom? displayseq.map((seqkey) => React.cloneElement(seq_dom[seqkey], { key: seq_dom[seqkey].key })) : null} */}
                    {seq_dom? displayseq.map(seqkey => seq_dom[seqkey]):null}
                </div>
                {btmbg_dom}
                {btmbar_stub}
                {bar_dom()}
            </div>
        }
        else if (device === 'MOBILE') {

            const topbg_dom = <img
                className='T2_bgimgtop'
                src={allimages.get(prebuildtemplatedesign_map[TEMPLATE2]['styletype'])['t2']['bgtop']}
            />

            const btmbg_dom = <img
                className='T2_bgimgbtm'
                src={allimages.get(prebuildtemplatedesign_map[TEMPLATE2].styletype)['t2']['bgbtm']}
            />

         

            const title_border_bg = <div
                style={{
                    width: '100%',
                    height: ht,
                    placeContent: 'center',
                    display: 'flex',
                    position: 'relative',
                    scrollSnapAlign: 'start'
                }}
            >
                {T2titles_dom('100%')}
            </div>

            if (showtitle) {
                return <div
                    id="ilookupt1"
                    key={'MOBILE_MAIN'}
                    style={{
                        overflowY: props.showpromote ? 'hidden' : '',
                        color: fontcolor, backgroundImage: `url(${textures[0]})`,
                        backgroundColor: templatecolor,
                        fontFamily: priff,
                        marginTop: menutype === 'stickytopnav' ? stickytopnavht : 0,
                        overflowX: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'center',
                        zIndex: 0,
                        overflowX:'hidden',
                    }}
                >
                    {mainimg_dom(wt, 999)}
                    {topbg_dom}
                    {T2titles_dom('100%')}
                    {/* {seq_dom ? displayseq.map((seqkey, i) => React.cloneElement(seq_dom[seqkey], { key: seq_dom[seqkey].key })) : null} */}
                    {seq_dom? displayseq.map(seqkey => seq_dom[seqkey]):null}
                    {btmbg_dom}
                    {btmbar_stub}
                    {bar_dom()}
                </div>
            }
            else {
                return <div id="ilookupt1" key={'MOBILE_MAIN'} style={{ overflowY: props.showpromote ? 'hidden' : '',overflowX:'hidden', color: fontcolor, backgroundImage: `url(${textures[0]})`, backgroundColor: templatecolor, overflowX: 'hidden', display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', zIndex: 0, fontFamily: priff }}>
                    {title_border_bg}
                </div>
            }

        }
    }
    else {
        return <></>
    }
}

export default T2